export default "__VITE_ASSET__CkwpxX19__"